import React, { useState, useEffect } from "react";
import styles from "./kohere.module.css";
import Layout from "../../Components/Layout";
import Myaccount from "./Myaccount";
import TeamTabs from "./TeamTabs";
import { ImUser } from "react-icons/im";
import UpdateTeams from "./UpdateTeams";
import { getTeamsByUserId } from "../../Services/APIrequests";

const Mykohere = () => {
  const [activeTab, setActiveTab] = useState(0); 
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const response = await getTeamsByUserId();
        if (response.data.success) {
          setTeams(response.data.teams || []);
        }
      } catch (error) {
        console.error("Failed to fetch teams:", error);
      }
    };

    fetchTeams();
  }, []);

  const handleButtonClick = (index) => {
    setActiveTab(index);
  };
 

  return (
    <Layout Active={"My Koheres"}>
      <div className={styles.Dashboard_container}>
        <div className={styles.buttton_container}>
          <div className={styles.status_btns}>
            <button
              className={`order_statusbuttons ${activeTab === 0 ? "active" : ""}`}
              onClick={() => handleButtonClick(0)}
              type="button"
            >
              <ImUser size={20} />
              My Account
            </button>

            <TeamTabs
              teams={teams}
              activeTab={activeTab}
              onTabClick={handleButtonClick}
            />
          </div>
        </div>

        {/* Conditional Rendering */}
        {activeTab === 0 ? (
          <Myaccount teams={teams} setTeams={setTeams} setActiveTab={setActiveTab} />
        ) : (
          <UpdateTeams activeTab={activeTab} teams={teams} setTeams={setTeams} />
        )}
      </div>
    </Layout>
  );
};

export default Mykohere;
